<script setup lang="ts">
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import ConnectivityBanner from '@/components/ConnectivityBanner.vue';
</script>

<template>
  <ConnectivityBanner />
  <router-view v-slot="{ Component }">
    <transition name="lv-fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
  <Toast position="top-right" />
  <ConfirmDialog />
</template>

<style>
.lv-fade-enter-active,
.lv-fade-leave-active {
  transition:
    opacity 180ms cubic-bezier(0.32, 0.72, 0.3, 1),
    transform 180ms cubic-bezier(0.32, 0.72, 0.3, 1);
}
.lv-fade-enter-from {
  opacity: 0;
  transform: translateY(4px);
}
.lv-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
